var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90674 0.192468C7.16882 0.417107 7.19917 0.81167 6.97454 1.07375L2.32317 6.50034L6.97454 11.9269C7.19917 12.189 7.16882 12.5836 6.90674 12.8082C6.64467 13.0328 6.2501 13.0025 6.02546 12.7404L1.02546 6.90708C0.824845 6.67303 0.824845 6.32765 1.02546 6.09359L6.02546 0.260259C6.2501 -0.00181976 6.64467 -0.0321707 6.90674 0.192468Z",
    fill: "#629BF8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowIcon.fa7f5f4424b57feb0beece09b32f6598.svg";